import {
  DefaultButton,
  IContextualMenuProps,
  Label,
  Modal,
  PrimaryButton,
  Stack,
  TooltipHost,
} from '@fluentui/react';
import { CompanyBusinessRuleInput } from 'common/types/globalTypes';
import { FormProvider, useForm } from 'react-hook-form';
import { CompanyConfigurationCategories_companyConfigurationCategories_nodes } from '../../__generated__/CompanyConfigurationCategories';
import { ModalHeader } from '../ModalHeader';
import RenderField from '../RenderField';
import { NewRuleInput } from '../types';
import { useStyles } from './index.styles';

export interface AddRuleModalProps {
  selectedNode: CompanyConfigurationCategories_companyConfigurationCategories_nodes;
  onClose: () => void;
  onAdd: (newRule: NewRuleInput) => void;
}

export const AddRuleModal: React.FC<AddRuleModalProps> = ({
  selectedNode,
  onClose,
  onAdd,
}) => {
  const styles = useStyles();
  const formMethods = useForm<CompanyBusinessRuleInput>({
    mode: 'all',
    defaultValues: {
      columnHint: '',
      booleanValue: false,
      smallintValue: null,
      numericValue: null,
      amountValue: null,
      textValue: '',
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { isDirty },
  } = formMethods;

  const onSubmit = handleSubmit((values) => {
    onAdd(values);
  });
  const menuProps: IContextualMenuProps = {
    items: [
      {
        key: 'saveAndAddNew',
        text: 'Save and add new',
        onClick: (values) => {
          onSubmit();
          reset();
        },
      },
    ],
  };

  return (
    <Modal isOpen isBlocking>
      <FormProvider {...formMethods}>
        <Stack className={styles.container}>
          <ModalHeader onClose={onClose} title="Add Rule" />
          <Stack
            horizontal
            tokens={{
              padding: 20,
              childrenGap: 30,
            }}
            className={styles.bodyContainer}
          >
            <TooltipHost content={selectedNode.additionsColumnHint ?? ''}>
              <Label>Settings </Label>
            </TooltipHost>
            {/* Render based on layout type */}
            {selectedNode?.additionsBusinessRuleLayoutType && (
              <RenderField
                layoutType={selectedNode?.additionsBusinessRuleLayoutType}
                isUpdatable
              />
            )}
          </Stack>

          <Stack
            horizontal
            horizontalAlign="end"
            tokens={{ childrenGap: 20, padding: 20 }}
          >
            <PrimaryButton
              text="Add Rule"
              onClick={() => {
                onSubmit();
                onClose();
              }}
              disabled={!isDirty}
              split
              menuProps={menuProps}
            />
            <DefaultButton text="Cancel" onClick={onClose} />
          </Stack>
        </Stack>
      </FormProvider>
    </Modal>
  );
};
